$(() => {

    $(".create-user-type-container").on("click", function() {
        const userType = $(this).data("user-type");

        if (userType === "NemId") {
            $("#NemId").prop("checked", true);
        }

        if (userType === "Anden") {
            $("#Anden").prop("checked", true);
        }

        if (userType === "Ad") {
            $("#Ad").prop("checked", true);
        }

        $(".create-user-type-container").removeClass("selected");
        $(this).addClass("selected");
    });

    $("#loginModal").on("shown.bs.modal", function() {
        $("#loginModal").trigger("focus");
    });

    $("#anden-bruger").on("click", function(e) {
        e.preventDefault();
        
        const andenBrugerUrl = $(this).attr("href");
        const email = $("#Email").val();

        $.ajax({
            url: `/authentication/DoesDomainPartExistAsAd?email=${email}`,
            success: function (result) {
                if (result !== null && result !== undefined) {
                    if (result.adExists) {
                        const modal = $("#loginModal");
                        modal.modal().show();
                        
                        const yesBtn = modal.find(".modalYesBtn");

                        yesBtn.off("click").on("click", function() {
                            window.location.assign(andenBrugerUrl);
                        });
                    } else {
                        window.location.assign(andenBrugerUrl);
                    }
                }
            }
        });
    });
});